class $742e3b578a6dc587$export$27603377d2467cd2 {
    constructor(){
        this.toggleSwitch = document.querySelector('.toggle__btn');
        this.toggleDiv = document.querySelector('.toggle__background');
        this.toggleSwitch.addEventListener('click', this.switchTheme.bind(this));
        if (localStorage.getItem('theme') === 'dark') {
            this.setTheme('dark');
            this.toggleSwitch.classList.add('toggle__btn--3');
        } else if (localStorage.getItem('theme') === 'light') {
            this.setTheme('light');
            this.toggleDiv.classList.add('toggle__btn--2');
        }
    }
    setTheme(themeName) {
        localStorage.setItem('theme', themeName);
        document.documentElement.setAttribute('data-theme', themeName);
    }
    switchTheme() {
        if (this.toggleDiv.classList.contains('toggle__btn--2')) {
            this.toggleDiv.classList.remove('toggle__btn--2');
            this.setTheme('dark');
            this.toggleSwitch.classList.add('toggle__btn--3');
            return;
        }
        if (this.toggleSwitch.classList.contains('toggle__btn--3')) {
            document.documentElement.removeAttribute('data-theme');
            this.toggleSwitch.classList.remove('toggle__btn--3');
            this.setTheme('');
            return;
        }
        this.toggleDiv.classList.add('toggle__btn--2');
        this.setTheme('light');
    }
}


class $df8b18b1000aa921$export$7e4e282af21c19f6 {
    setInput(input) {
        const inputCommas = input.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        if (this.input) this.input.value = inputCommas;
    }
    constructor(){
        this.input = document.querySelector('input');
    }
}
const $df8b18b1000aa921$export$b3890eb0ae9dca99 = new $df8b18b1000aa921$export$7e4e282af21c19f6();


class $9698a37a509a960c$export$694e0d28c7ffc90c {
    constructor(){
        this.length = 0;
        this.top = null;
    }
    push(item) {
        const newNode = $9698a37a509a960c$var$createNode(item);
        newNode.next = this.top;
        this.top = newNode;
        this.length++;
    }
    pop() {
        if (this.top === null) {
            console.warn("Stack is empty");
            return;
        }
        const data = this.top.data;
        this.top = this.top.next;
        this.length--;
        return data;
    }
    peek() {
        return this.top?.data;
    }
}
function $9698a37a509a960c$var$createNode(data) {
    const newNode = new $9698a37a509a960c$var$Node(data);
    newNode.next = null;
    return newNode;
}
class $9698a37a509a960c$var$Node {
    constructor(data){
        this.data = data;
        this.next = null;
    }
}


class $29d192046984c489$var$CalculatorState {
    #userInput;
    #displayInput;
    get input() {
        return this.#userInput;
    }
    set input(value) {
        this.#userInput = value;
        if (value) this.displayInput = value;
    }
    get displayInput() {
        return this.#displayInput;
    }
    set displayInput(value) {
        this.#displayInput = value;
        (0, $df8b18b1000aa921$export$b3890eb0ae9dca99).setInput(value);
    }
    reset() {
        this.operatorStack = new (0, $9698a37a509a960c$export$694e0d28c7ffc90c)();
        this.operandStack = new (0, $9698a37a509a960c$export$694e0d28c7ffc90c)();
        this.result = 0;
        this.resetInput();
        (0, $df8b18b1000aa921$export$b3890eb0ae9dca99).setInput(this.result.toString());
    }
    resetInput() {
        this.#userInput = '';
        this.#displayInput = '';
    }
    constructor(){
        this.result = 0;
        this.operatorStack = new (0, $9698a37a509a960c$export$694e0d28c7ffc90c)();
        this.operandStack = new (0, $9698a37a509a960c$export$694e0d28c7ffc90c)();
        this.#userInput = '';
        this.#displayInput = '';
    }
}
const $29d192046984c489$export$ca000e230c0caa3e = new $29d192046984c489$var$CalculatorState();




const $a2195685233c14ed$export$e41ccaa3e755a346 = (token)=>{
    const { operandStack: operandStack, operatorStack: operatorStack, input: currentInput } = (0, $29d192046984c489$export$ca000e230c0caa3e);
    if ($a2195685233c14ed$var$isEmptyInput(operatorStack.length, operandStack.length)) (0, $29d192046984c489$export$ca000e230c0caa3e).input += token;
    else if ($a2195685233c14ed$var$isNotFirstOperator(currentInput, operatorStack.length) && !currentInput) operatorStack.push(token);
    else if ($a2195685233c14ed$var$isSingleOperand(operatorStack.length, operandStack.length)) (0, $29d192046984c489$export$ca000e230c0caa3e).input += token;
    else operatorStack.push(token);
};
const $a2195685233c14ed$var$isEmptyInput = (operatorLength, operandLength)=>{
    return operatorLength === 0 && operandLength === 0;
};
const $a2195685233c14ed$var$isNotFirstOperator = (currentInput, operatorLength)=>{
    return !currentInput && operatorLength !== 1;
};
const $a2195685233c14ed$var$isSingleOperand = (operatorLength, operandLength)=>{
    return operandLength === 1 && operatorLength !== 0;
};




class $6aad11adf5f8d355$export$770682f56f7e9e8f {
    add(a, b) {
        return a + b;
    }
    subtract(a, b) {
        return a - b;
    }
    multiply(a, b) {
        return a * b;
    }
    divide(a, b) {
        if (b === 0) return 'Error';
        return a / b;
    }
    processOperation() {
        for(let i = 0; i < (0, $29d192046984c489$export$ca000e230c0caa3e).operandStack.length; i++){
            const operator = (0, $29d192046984c489$export$ca000e230c0caa3e).operatorStack.pop();
            const secondOperand = (0, $29d192046984c489$export$ca000e230c0caa3e).operandStack.pop();
            const firstOperand = (0, $29d192046984c489$export$ca000e230c0caa3e).operandStack.pop();
            if (operator && firstOperand != null && secondOperand != null) {
                const result = this.calculate(operator, firstOperand, secondOperand);
                (0, $29d192046984c489$export$ca000e230c0caa3e).result = result;
                (0, $29d192046984c489$export$ca000e230c0caa3e).operandStack.push(+result);
            }
        }
        this.renderResult();
        (0, $29d192046984c489$export$ca000e230c0caa3e).resetInput();
    }
    renderResult() {
        (0, $df8b18b1000aa921$export$b3890eb0ae9dca99).setInput((0, $29d192046984c489$export$ca000e230c0caa3e).result.toLocaleString());
    }
    calculate(operator, firstOperand, secondOperand) {
        switch(operator){
            case '+':
                return this.add(firstOperand, secondOperand);
            case '-':
                return this.subtract(firstOperand, secondOperand);
            case '/':
                return this.divide(firstOperand, secondOperand);
            case '*':
                return this.multiply(firstOperand, secondOperand);
            default:
                return 'Error';
        }
    }
}



const $5fbb6cf92328828d$export$980a17ff6c1ce844 = (input)=>{
    const calculator = new (0, $6aad11adf5f8d355$export$770682f56f7e9e8f)();
    if (input) {
        (0, $29d192046984c489$export$ca000e230c0caa3e).operandStack.push(+input);
        (0, $29d192046984c489$export$ca000e230c0caa3e).resetInput();
    }
    if ((0, $29d192046984c489$export$ca000e230c0caa3e).operandStack.length > 1) calculator.processOperation();
};



const $a1703c6b57ecdae1$export$68029cdc044bcdd8 = (input)=>{
    if (input) {
        (0, $29d192046984c489$export$ca000e230c0caa3e).operandStack.push(+input);
        (0, $29d192046984c489$export$ca000e230c0caa3e).resetInput();
    }
    return (token)=>{
        (0, $29d192046984c489$export$ca000e230c0caa3e).operatorStack.push(token);
    };
};


const $795a1029f979ade1$export$d5f8e91b6f2b49e0 = {
    "+": (token, input)=>{
        (0, $5fbb6cf92328828d$export$980a17ff6c1ce844)(input);
        (0, $a1703c6b57ecdae1$export$68029cdc044bcdd8)()(token);
    },
    "-": (token, input)=>{
        (0, $5fbb6cf92328828d$export$980a17ff6c1ce844)(input);
        (0, $a2195685233c14ed$export$e41ccaa3e755a346)(token);
    },
    "*": (token, input)=>{
        (0, $5fbb6cf92328828d$export$980a17ff6c1ce844)();
        (0, $a1703c6b57ecdae1$export$68029cdc044bcdd8)(input)(token);
    },
    "/": (token, input)=>{
        (0, $5fbb6cf92328828d$export$980a17ff6c1ce844)();
        (0, $a1703c6b57ecdae1$export$68029cdc044bcdd8)(input)(token);
    },
    "=": (_token, input)=>{
        (0, $5fbb6cf92328828d$export$980a17ff6c1ce844)(input);
    },
    "0": (token)=>(0, $29d192046984c489$export$ca000e230c0caa3e).input += token,
    "1": (token)=>(0, $29d192046984c489$export$ca000e230c0caa3e).input += token,
    "2": (token)=>(0, $29d192046984c489$export$ca000e230c0caa3e).input += token,
    "3": (token)=>(0, $29d192046984c489$export$ca000e230c0caa3e).input += token,
    "4": (token)=>(0, $29d192046984c489$export$ca000e230c0caa3e).input += token,
    "5": (token)=>(0, $29d192046984c489$export$ca000e230c0caa3e).input += token,
    "6": (token)=>(0, $29d192046984c489$export$ca000e230c0caa3e).input += token,
    "7": (token)=>(0, $29d192046984c489$export$ca000e230c0caa3e).input += token,
    "8": (token)=>(0, $29d192046984c489$export$ca000e230c0caa3e).input += token,
    "9": (token)=>(0, $29d192046984c489$export$ca000e230c0caa3e).input += token,
    ".": (token)=>{
        if (!(0, $29d192046984c489$export$ca000e230c0caa3e).input.includes('.')) (0, $29d192046984c489$export$ca000e230c0caa3e).input += token;
    },
    "del": (_token)=>{
        const input = (0, $29d192046984c489$export$ca000e230c0caa3e).input.slice(0, -1);
        (0, $29d192046984c489$export$ca000e230c0caa3e).input = input;
    },
    "reset": (_token)=>{
        (0, $29d192046984c489$export$ca000e230c0caa3e).reset();
    }
};


class $2dd0072cd1e8ed8e$export$3ac5e585cf392ee0 {
    constructor(){
        this.keys = document.querySelector('.calculator__keys');
        this.keys.addEventListener('click', (e)=>{
            if (e.target.matches('button')) this.parseInput(e);
        });
    }
    parseInput(e) {
        const value = e.target.dataset.value;
        if (value) (0, $795a1029f979ade1$export$d5f8e91b6f2b49e0)[value](value, (0, $29d192046984c489$export$ca000e230c0caa3e).input);
    }
}


new (0, $742e3b578a6dc587$export$27603377d2467cd2)();
new (0, $2dd0072cd1e8ed8e$export$3ac5e585cf392ee0)();


//# sourceMappingURL=repo.a2c5a842.js.map
